import { Injectable } from '@angular/core';
import { retry } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const CART_KEY = 'cart_products';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  constructor() { }

  public saveToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    let now = new Date();
    let item: any;

    item = {
      value: token,
      expiry: now.getTime() + (60000 * 60),
    }

    localStorage.setItem(TOKEN_KEY, JSON.stringify(item));

    const itemStr = localStorage.getItem(TOKEN_KEY);
  }

  public getToken(): string | null {
    const itemStr = localStorage.getItem(TOKEN_KEY);

    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }

    try {
      const item = JSON.parse(itemStr);
      const now = new Date()
      // compare the expiry time of the item with the current time
      if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        localStorage.removeItem(TOKEN_KEY);
        localStorage.clear();
        return null;
      } else {
        this.saveToken(item.value);
      }
      return item.value
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.clear();
      return null;
    }
  }

  public saveUser(data:any): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(data));

    const itemStr = localStorage.getItem(USER_KEY);
  }

  public getUser(): any | null {
    const itemStr = localStorage.getItem(USER_KEY);
    if(itemStr){
      return JSON.parse(itemStr);
    }
    return null;
  }

  public getCart(): boolean {
    const itemStr = localStorage.getItem(CART_KEY);
    if (!itemStr) {
      return false;
    }

    return true;
  }

  signOut(): void {
    let username:any = (localStorage.getItem('username'))?localStorage.getItem('username'):'';
    let password:any = (localStorage.getItem('password'))?localStorage.getItem('password'):'';
    let remember_me:any = (localStorage.getItem('remember_me'))?localStorage.getItem('remember_me'):false;
    localStorage.clear();
    if(remember_me){
      localStorage.setItem('username', username);
      localStorage.setItem('password', password);
      localStorage.setItem('remember_me', remember_me);
    }
  }

  isLogin(): boolean{
    const itemStr = localStorage.getItem(TOKEN_KEY);
    if (!itemStr) {
      return false;
    }else{
      return true;
    }
  }
}
